import { render, staticRenderFns } from "./PPTTemplate.vue?vue&type=template&id=4a4faa17&scoped=true&"
import script from "./PPTTemplate.vue?vue&type=script&lang=js&"
export * from "./PPTTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PPTTemplate.vue?vue&type=style&index=0&id=4a4faa17&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4faa17",
  null
  
)

export default component.exports